import { createFileRoute } from "@tanstack/react-router";
import { getLocale, getCurrency } from "@coras-io/web-components/helpers";
import { redirect } from "@tanstack/react-router";
import { config, site } from "../config.ts";

export const Route = createFileRoute("/")({
  loader: async () => {
    const locale = site.detectLocale ? getLocale() : config.locale;
    const currency = site.detectLanguage
      ? getCurrency(locale)
      : config.currency;

    redirect({
      to: "/$locale/$currency",
      params: { locale, currency },
      throw: true,
      statusCode: 307,
      replace: true,
    });
  },
});
